<template>
  <div class="box">
    <v-server-table 
      ref="datatable" 
      :url="api" 
      :name="tableName" 
      :columns="columns" 
      :options="options"/>

    <vuetablemodifier_form 
      ref="modifierSetsForm" 
      @modifierset-saved="refresh"/>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import VuetableCheckbox from '../../../components/vuetable2/checkbox/state';

const TableName = 'VUETABLE_MODIFIER';

export default {
    data() {
        var that = this;
        let canManageItems = Auth.hasAnyPermission(
            'franchise_manage_items',
            'franchise_manage_modifiers',
        );

        let actionButtons = [
            {
                title: 'Create Modifier',
                action: () => {
                    this.showForm(null);
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        return {
            modifier: {},
            tableName: TableName,
            api: Laroute.route('franchise.inventory.modifier.index'),
            columns: ['name', 'products'],
            options: {
                checkbox: canManageItems,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.modifier.delete',
                    ),
                    delete_title: 'Delete Modifiers',
                },
                customFilters: ['outlet_id'],
                initFilters: { outlet_id: that.$store.getters.activeOutlet },
                sortable: ['name'],
                headings: {
                    name: 'Name',
                    products: 'Products',
                    actions: 'Action',
                },
                templates: {
                    products(h, row) {
                        return require('./vuetablemodifier_items.jsx')(h, row);
                    },
                },
                csv_url: Laroute.route(
                    'franchise.inventory.modifier.exportAsFile',
                    { type: 'CSV' },
                ),
                pdf_url: Laroute.route(
                    'franchise.inventory.modifier.exportAsFile',
                    { type: 'PDF' },
                ),
                actionButtons: actionButtons,
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showForm,
            },
        };
    },
    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    created() {
        this.$store.registerModule(`CHECKBOX_${TableName}`, VuetableCheckbox);
    },

    methods: {
        showForm(row) {
            this.$refs.modifierSetsForm.$emit('show-form', row);
        },

        refresh() {
            this.$refs.datatable.refresh();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/vuetable_modifier.vue